export default {
  modules_file_drop() {
    return {
      imageDropAndPaste: {
        handler: (_data, _type, imageData) => {
          // Convert image to file and handle as attachment
          const blob = imageData.toBlob()
          const file = new File([blob], imageData.name, {
            type: imageData.type,
          })
          this.addAttachments([file])
        },
        nonImageHandler: (files) => this.addAttachments(files),
      },
    }
  },

  addAttachments(files) {
    const input = this.hiddenInput.form.querySelector('input[type="file"]')
    // Signature editor has no LiveView upload input; attachments unsupported.
    if (!input) return
    this.uploadTo(input.form, input.name, files)
  },
}
